import { NgModule, ValueProvider } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SplitButtonItemDirective, SplitButtonItemsDirective } from './items.directive';
import { SplitButtonComponent } from './splitbutton.component';
import { SplitButtonModule } from './splitbutton.module';
/**
 * NgModule definition for the SplitButton component with providers.
 */
export class SplitButtonAllModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, SplitButtonModule],
    exports: [
        SplitButtonModule
    ],
    providers:[
        
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function SplitButtonAllModule_tsickle_Closure_declarations() {
/** @type {?} */
SplitButtonAllModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SplitButtonAllModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
